import { configureStore, createAction, getDefaultMiddleware } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import {
  user,
  crumbReducer,
  taxonomy,
  modal,
  toast,
  collections,
  dialog,
  tags,
  asset,
  files,
  search,
  featureFlags,
  env,
  release,
} from 'store'
import { featureFlagMiddleware } from './featureFlag/middleware'
import rootSaga from './rootSaga'
import { combineReducers } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'

export const startGallery = createAction('START_GALLERY')
// Collections, Assets, Crumbs, Taxonomies (Categories ), User, Toast Reducers

const sagaMiddleWare = createSagaMiddleware({})

const rootReducer = combineReducers({
  user,
  crumbs: crumbReducer,
  taxonomy,
  dialog,
  toast,
  modal,
  asset,
  collections,
  tags,
  files,
  search,
  featureFlags,
  env,
  release,
})

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['crumbs'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [...getDefaultMiddleware({ serializableCheck: false }), sagaMiddleWare, featureFlagMiddleware],
  devTools: true,
})

sagaMiddleWare.run(rootSaga)
export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
